import React__default from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import tokens from '@te-digi/styleguide-tokens';
import { media } from '../utils/styles/media.js';
import { hexToRGBA } from '../utils/styles/hex-to-rgba.js';

/**
 * Duplicated in _divider.scss.
 */
const StyledDivider = styled.div.withConfig({
  componentId: "sg1390__sc-14velj3-0"
})(["", " ", " ", " ", " ", ""], props => props.$variant === 'vertical' && props.$noMargin && css(["background-color:", ";height:100%;margin-left:0;margin-right:0;width:1px;"], tokens.color['neutral-4']), props => props.$variant === 'vertical' && !props.$noMargin && css(["background-color:", ";height:100%;margin-left:", ";margin-right:", ";width:1px;"], tokens.color['neutral-4'], tokens.space.xl, tokens.space.xl), props => props.$variant !== 'vertical' && props.$noMargin && css(["border:0;border-top:1px solid ", ";margin-bottom:0;margin-top:0;"], tokens.color['neutral-4']), props => props.$variant !== 'vertical' && !props.$noMargin && css(["border:0;border-top:1px solid ", ";margin-bottom:", ";margin-top:", ";"], tokens.color['neutral-4'], tokens.space.xl, tokens.space.xl), props => props.$variant === 'sidebar' && css(["border-top-color:", ";margin-left:-", ";margin-right:-", ";", "{margin-left:-", ";margin-right:-", ";}", "{background-image:linear-gradient( to right,", " 0,", " ", " );border-top:0;height:1px;}"], tokens.color['neutral-3'], tokens.space.md, tokens.space.md, media.lg, tokens.space.xl, tokens.space.xl, media.width(1920), hexToRGBA(tokens.color['neutral-3'], 0), tokens.color['neutral-3'], tokens.space.xl));
const Divider = _ref => {
  let {
    as = 'div',
    className,
    noMargin,
    variant
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledDivider, {
    $noMargin: noMargin,
    $variant: variant,
    as: as,
    className: className
  });
};
Divider.displayName = 'Divider';
Divider.propTypes = {
  /**
   * Element or component used for the root node.
   */
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  className: PropTypes.string,
  /**
   * Disable default bottom margin.
   */
  noMargin: PropTypes.bool,
  variant: PropTypes.oneOf(['sidebar', 'vertical'])
};

export { Divider };
